import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchUserFeatures } from "../../actions/featureAccessActions";
import { hasMetricsReporting } from "../../utils/featureAccessHelpers";
import * as Icon from "react-feather";
import { notification } from "../../utils/utility";
import "./homepageToggle.scss";

const VIEWS = {
  dashboard: {
    id: "dashboard",
    label: "Analytics Dashboard",
    path: "/admin/dashboard",
  },
  scheduledEvents: {
    id: "scheduled-events",
    label: "Scheduled Events",
    path: "/admin/scheduled-events",
  },
};

const HomepageToggle = ({ fetchUserFeatures, features, loaded, loading }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const metricsEnabled = hasMetricsReporting(features);
  const analyticsLocked = loaded && !metricsEnabled;

  const activeView =
    location.pathname === VIEWS.scheduledEvents.path
      ? VIEWS.scheduledEvents.id
      : analyticsLocked
      ? VIEWS.scheduledEvents.id
      : VIEWS.dashboard.id;

  useEffect(() => {
    if (!loaded && !loading) {
      fetchUserFeatures();
    }
  }, [loaded, loading, fetchUserFeatures]);

  useEffect(() => {
    if (analyticsLocked && location.pathname === VIEWS.dashboard.path) {
      navigate(VIEWS.scheduledEvents.path, { replace: true });
    }
  }, [analyticsLocked, location.pathname, navigate]);

  const handleLockedAnalytics = () => {
    notification.upgrade("Upgrade your plan to access Analytics Dashboard.");
    navigate("/admin/manage-subscription");
  };

  const handleSelect = (view) => {
    if (view.id === VIEWS.dashboard.id && analyticsLocked) {
      handleLockedAnalytics();
      return;
    }

    if (location.pathname !== view.path) {
      navigate(view.path);
    }
  };

  return (
    <div className="admin-view-switcher">
      {[VIEWS.dashboard, VIEWS.scheduledEvents].map((view) => {
        const isLocked =
          view.id === VIEWS.dashboard.id && analyticsLocked;
        const isActive = activeView === view.id;

        if (isLocked) {
          return (
            <button
              key={view.id}
              type="button"
              className="admin-view-switcher__option admin-view-switcher__option--locked"
              onClick={() => handleSelect(view)}
              title="Upgrade your plan to access Analytics Dashboard"
            >
              <Icon.Lock size={14} />
              <span>{view.label}</span>
            </button>
          );
        }

        return (
          <button
            key={view.id}
            type="button"
            className={`admin-view-switcher__option${
              isActive ? " admin-view-switcher__option--active" : ""
            }`}
            onClick={() => handleSelect(view)}
            aria-pressed={isActive}
          >
            {view.label}
          </button>
        );
      })}
    </div>
  );
};

const mapStateToProps = (state) => ({
  features: state.featureAccess.features,
  loaded: state.featureAccess.loaded,
  loading: state.featureAccess.loading,
});

export default connect(mapStateToProps, { fetchUserFeatures })(HomepageToggle);
